import React from 'react';
import { LinkContainer } from 'react-router-bootstrap';
import AuthService from '../services/auth.service';

var authService = new AuthService();

export const AdminLinkContainer = ({ component: Component, ...rest }) => (
    authService.isAdmin()
        ?
        <LinkContainer {...rest} render={props => (
            <Component {...props} />
        )}
        />
        : null
);


// WEBPACK FOOTER //
// ./src/components/AdminLinkContainer.js